import { IGetCurrentUserResponse } from './getCurrentUser.types';

export const testBuyerUserData: IGetCurrentUserResponse = {
  uuid: 'bc97ff2c-e551-4ee0-a109-3684956394ea',
  firstName: 'Usaid',
  lastName: 'Test',
  email: 'usaid.sherwani@metycle.com',
  emailVerified: true,
  role: 'company.role.buyer',
  currentOperationsMode: 'operations.mode.buyer',
  company: {
    verificationStatus: 'company.verification.approved',
    detectedPortalId: 'aec16c400b5d73b847c3e85f714e6f0d',
    pipedriveId: '189',
  },
};
export const testSellerUserData: IGetCurrentUserResponse = {
  uuid: 'd6766386-695c-4917-9bf6-1d863ee792d1',
  firstName: 'Son',
  lastName: 'Goku',
  email: 'songoku@metycle.com',
  emailVerified: true,
  role: 'company.role.seller',
  currentOperationsMode: 'operations.mode.seller',
  company: {
    verificationStatus: undefined,
    detectedPortalId: undefined,
    pipedriveId: '',
  },
};

export const testBuyerUserNotVerifiedData: IGetCurrentUserResponse = {
  uuid: 'bc97ff2c-e551-4ee0-a109-3684956394ea',
  firstName: 'Usaid',
  lastName: 'Test',
  email: 'usaid.sherwani@metycle.com',
  emailVerified: false,
  role: 'company.role.buyer',
  currentOperationsMode: 'operations.mode.buyer',
  company: {
    verificationStatus: undefined,
    detectedPortalId: undefined,
    pipedriveId: '189',
  },
};

export const testSellerUserNotVerifiedData: IGetCurrentUserResponse = {
  uuid: 'e3870b7f-cfe5-4cce-ad57-0b879d1b4f06',
  firstName: 'usaid',
  lastName: 'seller2',
  email: 'usaid.seller@metycle.com',
  emailVerified: false,
  role: 'company.role.seller',
  currentOperationsMode: 'operations.mode.seller',
  company: {
    verificationStatus: undefined,
    detectedPortalId: undefined,
    pipedriveId: '200',
  },
};

export const testBuyerAndSellerUserData: IGetCurrentUserResponse = {
  uuid: 'd6766386-695c-4917-9bf6-1d863ee792d1',
  firstName: 'Son',
  lastName: 'Goku',
  email: 'songoku@metycle.com',
  emailVerified: true,
  role: 'company.role.seller_and_buyer',
  currentOperationsMode: 'operations.mode.seller',
  company: {
    verificationStatus: undefined,
    detectedPortalId: undefined,
    pipedriveId: '',
  },
};

export const testBuyerUserDeclinedData: IGetCurrentUserResponse = {
  ...testBuyerUserData,
  emailVerified: false,
  company: {
    ...testBuyerUserData.company,
    verificationStatus: 'company.verification.declined',
  },
};
